/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_LedeInputs */

const en_price_page_lede = /** @type {(inputs: Price_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first 3 workouts and 3 meal scans cost nothing. After that the app is 49 zł a month or 249 zł a year. Booking a specialist and anything they give you is never part of that: you pay them for visits, at their own prices.`)
};

const pl_price_page_lede = /** @type {(inputs: Price_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwsze 3 treningi i 3 skany posiłków nic nie kosztują. Potem aplikacja to 49 zł miesięcznie albo 249 zł rocznie. Rezerwacje i wszystko, co dostajesz od specjalisty, są poza tym: za wizyty płacisz specjaliście, według jego cennika.`)
};

/**
* | output |
* | --- |
* | "Your first 3 workouts and 3 meal scans cost nothing. After that the app is 49 zł a month or 249 zł a year. Booking a specialist and anything they give you is..." |
*
* @param {Price_Page_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_lede = /** @type {((inputs?: Price_Page_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_lede(inputs)
	return en_price_page_lede(inputs)
});